import { parseISO } from "date-fns";
import axios from "@/common/services/axios";
import { Competition } from "@/common/models/competition";
import {
  Match,
  MatchResponse,
  MatchResultRequest,
  MatchStatsResponse,
  MatchStatus,
  Stats,
} from "@/common/models/match";

const processMatch = (raw: MatchResponse): Match => ({
  id: raw.id,
  competition: raw.competition_id,
  startTime: parseISO(raw.start_time),
  endTime: parseISO(raw.end_time),
  teams: raw.teams.map((t) => ({
    team: t.team_id,
    kind: t.kind,
    result: t.result,
  })),
  football: {
    round: raw.football ? raw.football.round : "",
    roundCategory: raw.football ? raw.football.round_category : "",
  },
  status: raw.status as unknown as MatchStatus,
  stats: null,
  bonus: false,
  summaryVideoUrl: raw.additional_info?.summary_video_url ?? "",
  created: parseISO(raw.created_at),
  updated: parseISO(raw.updated_at),
  createdBy: raw.created_by,
  updatedBy: raw.updated_by,
});

const processMatchStats = (raw: MatchStatsResponse, id: string): Stats => ({
  id,
  football: {
    bets: {
      winner: {
        homePercent: raw.football.bets.winner.home_percent,
        visitingPercent: raw.football.bets.winner.visiting_percent,
        drawPercent: raw.football.bets.winner.draw_percent,
      },
    },
  },
});

export const fetchCompetitionMatches = async (competition: Competition): Promise<Match[]> => {
  const response = await axios.get<MatchResponse[]>(
    `/competitions/${competition.id}/matches?orderBy=start_time`,
  );
  return Array.isArray(response.data) ? response.data.map(processMatch) : [];
};

export const updateMatchResult = async (
  competition: Competition,
  match: Match,
  result: MatchResultRequest,
) => {
  await axios.post(`/competitions/${competition.id}/matches/${match.id}:updateResult`, result);
};

export const updateMatchSummaryVideoUrl = async (
  competition: Competition,
  match: Match,
  summaryVideoUrl: string,
): Promise<void> => {
  await axios.patch(`/competitions/${competition.id}/matches/${match.id}`, {
    additional_info: { summary_video_url: summaryVideoUrl },
  });
};

export const fetchMatchStats = async (match: Match, competition: Competition): Promise<Stats> => {
  const response = await axios.get<MatchStatsResponse>(
    `/competitions/${competition.id}/matches/${match.id}/stats?type=bets-winner`,
  );
  return processMatchStats(response.data, match.id);
};
